import { render, staticRenderFns } from "./Cis.vue?vue&type=template&id=b2cba966&scoped=true"
import script from "./Cis.vue?vue&type=script&lang=js"
export * from "./Cis.vue?vue&type=script&lang=js"
import style0 from "./Cis.vue?vue&type=style&index=0&id=b2cba966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cba966",
  null
  
)

export default component.exports